<template>
    <div class="download" :class="divclass">
        <div class="body">
            <div class="download__content" :class="$googleplay || $appstore ? 'download__content--open' :''">
                <div class="download__txt">
                    <p v-show="!$googleplay && !$appstore">Available soon on your mobile</p>
                    <p v-show="$googleplay || $appstore">Be healthy everyday. Download the app now.</p>
                </div>
                <div class="download__img" :class="!$googleplay && !$appstore ? '': ''">
                    <a :href="$googleplay" target="_blank" :class="!$googleplay ? 'download__disabled': ''">
                        <img src="/img/icon-playstore.png" alt="Google Play" class="google">
                    </a>
                    <a :href="$appstore" target="_blank" :class="!$appstore ? 'download__cursornone': ''">
                        <img src="/img/icon-apple.png" alt="App Store" class="apple" :class="!$appstore ? 'download__disabled': ''">
                        <p class="download__coming" :class="$appstore ? 'display--none': ''">
                            COMING SOON
                        </p>
                    </a>
                </div>
            </div>
            <div class="download__signup" v-if="!$googleplay && !$appstore">
                <div class="doctor__btn" :class="!$doctor ? 'doctor__btn--soon' : ''">
                    <a href="/signup" target="_blank">Sign up for updates</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Download',
  props: ['divclass'],
};
</script>
